<template>

    <div class="fuid-langsitcher">

        <ul class="fuid-langsitcher__ul d-flex">

            <li v-for="(lang, i) in langs"
                :key="`Lang${i}`"
                class="fuid-langsitcher__li d-none d-md-flex align-items-center justify-content-center"
                :class="$i18n.locale == lang ? 'active' : 'inactive'"
                @click.prevent="switchLocale(lang)"
            >{{ lang }}</li>

        </ul>

    </div>

</template>

<script>
    export default {

        data () {

            return {

                langs: this.$i18n.availableLocales

            }
            
        },

        methods: {

            switchLocale(lang){

                this.$i18n.locale = lang

            }

        }

    }
</script>

<style lang="scss" scoped>

</style>